import React, { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { v4 as uuidv4 } from 'uuid';
import { appInfo } from "../AppInfo";
import { initialUserInfo } from "../models/response/account/user-info";
import { RootState } from "../state/reducers";
type CommonContextType = {
    children: React.ReactNode
}

type CommonStoreType = {
    getDataGridStorageKey: (key: string) => string,
    checkAccesiableTo: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => boolean,
    checkAccesiableToV2: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => boolean,

    createUUID: () => string,
    translate: (code: string) => string
}

const CommonContext = createContext({} as CommonStoreType);
const useCommonContext = () => useContext(CommonContext)
const CommonProvider = ({ children }: CommonContextType) => {
    const user = useSelector((state: RootState) => state.auth.user_info) || initialUserInfo
    const { localized_resources } = useSelector((x: RootState) => x.localizedResource)
    const store: CommonStoreType = {
        getDataGridStorageKey: (key: string) => {
            return `dataGridStorangeKey.${appInfo.versionDataGridStorageKey || ""}.${user.id}.${key}`
        },
        checkAccesiableTo: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => {
            return true;
            // const api = user.apis.filter(x => x.method == httpMethod).find(x => x.url === path || x.url === `api/${path}`);
            // console.log({
            //     api
            // });

            // if (api) return true;
            // return false;
        },
        checkAccesiableToV2: (path: string, httpMethod: "GET" | "POST" | "PUT" | "DELETE") => {
            // return true;
            const api = user.apis.filter(x => x.method == httpMethod).find(x => x.url === path || x.url === `api/${path}`);
            // console.log({
            //     api
            // });

            if (api) return true;
            return false;
        },
        createUUID: () => {
            return uuidv4();
        },
        // translate: (vi: string) => {
        //     return vi;
        // },
        translate: (code: string) => {
            // if (code == "MappingFormulaForm.Max.Item.OffsetLabel.HelpText") {
            //     return localized_resources.get(code) ?? "xxx";
            // }
            return localized_resources.get(code) ?? code;
        }

    }
    return (
        <CommonContext.Provider value={store}>
            {children}
            <ToastContainer />
        </CommonContext.Provider>
    );
}
export {
    CommonProvider,
    useCommonContext
};

